import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { menuState } from "src/states/menu";
import { request } from "../api";
import { GET_MENU } from "../querykeys";
import { BaseResponse } from "../types/baseRespones";
import { MenuType } from "../types/menu";
import { buildMenuTree } from "../util/buildMenuTree";
import { readAccessToken } from "../functions/authFunctions";
import { MenuSet } from "src/data/menu.static";

const useMenuData = () => {
  const setMenuList = useSetRecoilState(menuState);
  const accessToken = readAccessToken();
  // 여기서 메뉴 들고오기 contextApi

  const { data: menuData = [] } = useQuery({
    queryKey: [GET_MENU],
    queryFn: () =>
      request<BaseResponse<MenuType[]>>({
        method: "GET",
        url: `/stm-menu/menu`,
      }).then((res) => res.data),
    enabled: !!accessToken,
  });

  useEffect(() => {
    MenuSet(menuData);
    if (menuData) {
      setMenuList(buildMenuTree(menuData));
    }
  }, [menuData]);
};

export default useMenuData;
